export const handleScrollTo = {
  type: 'function',
  required: true,
}

export const scrollTo = (
  xCoord: number,
  yCoord: number,
  source: Element | Window = window,
) => {
  source.scrollTo(xCoord, yCoord)
}
